import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isFinite } from 'lodash-es';
import { formatPriceStringV2 } from 'site-modules/shared/utils/price-utils';

export function PricingBlock({
  title = undefined,
  price = 0,
  pricePrefix = '',
  subcopy = '',
  priceClasses = '',
  priceBlockClasses = '',
}) {
  const shouldRenderPrice = price !== '' && (typeof price === 'string' || isFinite(price));

  return (
    <div className={classNames('d-flex justify-content-between', priceBlockClasses)}>
      <div>
        {title}
        <div className="medium text-gray-dark">{subcopy}</div>
      </div>
      {shouldRenderPrice && (
        <div className={classNames('ps-0_5', priceClasses)}>
          {pricePrefix}
          {typeof price === 'string' ? price : formatPriceStringV2(price)}
        </div>
      )}
    </div>
  );
}

PricingBlock.propTypes = {
  title: PropTypes.node,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pricePrefix: PropTypes.string,
  subcopy: PropTypes.node,
  priceClasses: PropTypes.string,
  priceBlockClasses: PropTypes.string,
};
